<template>
  <div class="studies_bg">
    <mainheader></mainheader>
    <div class="container pt-10">
      <div class="row has-header pb-20">
        <div class="col-xs-6 col-sm-9 col-md-10 col-lg-10">
          <span class="profile color_top">Profile</span>
        </div>
      </div>
      <div class="contents white-bg pt-10">
        <div class="d-flex pt-10">
          <div class="col-3">
            <div class="row pt-10">
              <div class="name-avtar">
                <p>AVATAR</p>
                <div class="row">
                  <span>
                    <img class="img-responsive img-circle " :src="altImage" alt="profile" width="90px" height="90px" v-if="profileImage === null" />
                    <img class="img-responsive img-circle " :src="profileImage" alt="profile" width="90px" height="90px" v-if="profileImage !== null" />
                  </span>
                  <div class="d-flex pt-47">
                    <div>
                      <span class="pl-7" v-if="editMode">
                        <div class="file-upload"><input type="file" id="avatarImage" class="file-input" @change="onFileChange($event)" /><span class="fs-12">Upload</span></div>
                      </span>
                    </div>
                    <div>
                      <span v-if="editMode">
                        <a class="removepic" v-if="removePhotoToggle" v-on:click="removePhoto()">Remove photo</a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-9 profile-info">
            <div class="row pt-10">
              <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                <label class="name-txt">NAME</label>
                <input class="editableText pb-50" :disabled="!editMode" v-if="!editMode" :value="`${user.firstName} ${user.lastName}`" />
                <div v-if="editMode">
                  <div class="form-group row">
                    <label class="col-sm-6 col-form-label lable-f">First Name</label>
                    <div class="col-sm-6">
                      <input
                        type="text"
                        name="firstName"
                        v-validate="'required'"
                        class="f-input"
                        :class="{
                          input: true,
                          'is-danger': errors.has('firstName'),
                          'is-success': !errors.has('firstName')
                        }"
                        v-model="user.firstName"
                      />
                      <span v-if="!user.firstName" class="error-style display-block">first name is required field</span>
                    </div>
                  </div>
                </div>
                <div v-if="editMode">
                  <div class="form-group row">
                    <label class="col-sm-6 col-form-label lable-f">Last Name</label>
                    <div class="col-sm-6">
                      <input
                        type="text"
                        name="lastName"
                        v-validate="'required'"
                        :class="{
                          input: true,
                          'is-danger': errors.has('lastName'),
                          'is-success': !errors.has('lastName')
                        }"
                        class="f-input"
                        v-model="user.lastName"
                      />
                      <span v-if="!user.lastName" class="error-style display-block">last name is required field</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 card-height" v-if="user.userRole !== 'Pi'">
                <label class="name-txt">Company</label>
                <input class="editableText pb-50" v-model="user.client.name" disabled v-if="!editMode" />
                <input class="editableText pb-50 disableText" v-model="user.client.name" disabled v-if="editMode" />
              </div>
              <div v-if="awsCognitoAuthentication && awsCognitoAuthentication === true" class="col-lg-4 col-md-6 col-sm-6 col-xs-12 card-height">
                <label class="name-txt">Username</label>
                <input class="editableText pb-50" v-model="user.cognitoUsername" disabled v-if="!editMode" />
                <input class="editableText pb-50 disableText" v-model="user.cognitoUsername" disabled v-if="editMode" />
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 card-height">
                <label class="name-txt">Email</label>
                <input class="editableText text-lowercase" v-model="user.username" disabled v-if="!editMode" />
                <input
                  type="text"
                  name="email"
                  v-validate="'required|email'"
                  class="editableText"
                  :class="{
                    disableText: !awsCognitoAuthentication,
                    'edit-email-input': awsCognitoAuthentication
                  }"
                  :disabled="!awsCognitoAuthentication"
                  v-model="user.username"
                  v-if="editMode"
                />
                <span v-show="errors.has('email')" class="error-style">{{ errors.first("email") }}</span>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 card-height">
                <label class="name-txt">Mobile Number</label>
                <span :class="{ 'input-display': !editMode }">
                  <vue-tel-input class="p-0" @onInput="onInputUserPhone" ref="userPhoneNumber"></vue-tel-input>
                  <span v-if="user.phoneNumber && user.phoneNumber.length > 0 && !validMobile" class="error-style">Phone number is invalid</span>
                </span>
                <input class="editableText" :disabled="!editMode" v-model="user.phoneNumber" v-if="!editMode" />
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                <label class="name-txt">Work Number</label>
                <span :class="{ 'input-display': !editMode }">
                  <vue-tel-input class="p-0" @onInput="onInputWorkNumber" ref="userWorkNumber"></vue-tel-input>
                  <span v-if="user.workNumber && user.workNumber.length > 0 && !validWork" class="error-style">Work number is invalid</span>
                </span>
                <input class="editableText" type="text" v-if="!editMode" :disabled="!editMode" v-model="user.workNumber" />
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 card-height">
                <label class="name-txt"
                  >Role &nbsp;
                  <i class="fa fa-question-circle help_icon" aria-hidden="true" data-toggle="popover" tabindex="0" data-trigger="focus" data-content=" 1.Platform Admin <br> 2.Study admin " data-html="true"></i>
                </label>
                <input class="editableText pb-50 roleInputWidth" :title="user.userRoleUI" v-model="user.userRoleUI" disabled v-if="!editMode" />
                <input class="editableText pb-50 disableText roleInputWidth" v-model="user.userRoleUI" disabled v-if="editMode" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contents white-bg pt-10">
        <div class="col-md-6 col-sm-6 col-lg-6 col-xs-6 card-height" v-if="user.userRole === 'StudyAdmin'">
          <div class="switch-button d-flex">
            <div class="text col-md-12">PERMISSIONS</div>
          </div>
          <div class="switch-button d-flex">
            <div class="text col-md-6">
              Manage Activity Library
              <span class="fa fa-info-circle info-circle" aria-hidden="true" @click="toggleInfoDiv()" @blur="hidePopup()" tabindex="-1"></span>
              <div class="info-circle-div" v-show="infoDiv">
                Enabling the Manage Activity Library privilege will allow the member to create, modify, and archive activities in your instance's activity library.
              </div>
            </div>
            <span class="setting-btn-text">Off</span>
            <div class="switch-option">
              <label class="switch">
                <input type="checkbox" disabled v-model="user.activityLibraryAllowed" />
                <div class="slider round"></div>
              </label>
              <span class="setting-btn-text">On</span>
            </div>
          </div>
        </div>
      </div>
      <div class="contents pl-30 pr-30 pt-30 pb-30 white-bg">
        <div class="text-center ml-405 save-row mb-20">
          <button type="button" v-if="editMode" class="btn btn-md cancel-btn-2 cancle-margin" v-on:click="cancelProfile">
            Cancel
          </button>
          <button type="button" v-if="editMode" class="btn btn-md save-btn-2" v-on:click="updateProfileSave()">
            Save
          </button>
        </div>
        <div class="ml-762">
          <span v-if="!editMode" class="Change-password" v-on:click="showChangePassword()">Change password</span>
          <span type="button" class="edit-box" v-if="!editMode" v-on:click="editProfile()">Edit</span>
        </div>
      </div>
      <div class="contents pl-30 pr-30 white-bg bt-1" v-if="changePassword">
        <div class="row pt-20">
          <p class="mb-5 pl-30">Password requirements:</p>
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <ul class="validation-list">
              <li>
                minimum 8 characters
                <span v-if="showIcon">
                  <i v-if="minValid" class="fa fa-check-circle icon-valid" aria-hidden="true"></i>
                  <i v-if="!minValid" class="fa fa-times-circle icon-invalid" aria-hidden="true"></i>
                </span>
              </li>
              <li>
                at least 1 uppercase letter
                <span v-if="showIcon">
                  <i v-if="upperValid" class="fa fa-check-circle icon-valid" aria-hidden="true"></i>
                  <i v-if="!upperValid" class="fa fa-times-circle icon-invalid" aria-hidden="true"></i>
                </span>
              </li>
              <li>
                at least 1 lowercase character
                <span v-if="showIcon">
                  <i v-if="lowerValid" class="fa fa-check-circle icon-valid" aria-hidden="true"></i>
                  <i v-if="!lowerValid" class="fa fa-times-circle icon-invalid" aria-hidden="true"></i>
                </span>
              </li>
            </ul>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <ul class="validation-list">
              <li>
                at least 1 number
                <span v-if="showIcon">
                  <i v-if="numberValid" class="fa fa-check-circle icon-valid" aria-hidden="true"></i>
                  <i v-if="!numberValid" class="fa fa-times-circle icon-invalid" aria-hidden="true"></i>
                </span>
              </li>
              <li>
                at least 1 symbol (e.g @#$%)
                <span v-if="showIcon">
                  <i v-if="specialValid" class="fa fa-check-circle icon-valid" aria-hidden="true"></i>
                  <i v-if="!specialValid" class="fa fa-times-circle icon-invalid" aria-hidden="true"></i>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="row pb-20 pt-20">
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <input class="form-control" type="password" placeholder="Enter old password" v-model="password.oldPassword" />
            <span class="removepic fs-12">{{ this.msgOld }}</span>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <input class="form-control" type="password" placeholder="Enter new password" v-model="password.newPassword" v-on:keyup="validNewPassword(password.newPassword)" />
            <span class="removepic fs-12" v-if="msgMatch">New passwords do not match</span>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <input class="form-control" type="password" placeholder="Re-Enter new password" :disabled="confirmPasswordInput" v-on:keyup="validConfirmPassword(confirmPassword)" v-model="confirmPassword" />
          </div>
        </div>
        <div class="row pb-30 pt-30" v-if="changePasswordToggle">
          <div class="text-center pad-top20">
            <button type="button" class="btn btn-md cancel-btn" v-on:click="cancelPassword">
              Cancel
            </button>
            <button type="button" class="btn btn-md save-btn" v-on:click="updatePassword(password)" :disabled="disableChangePassword">
              Change Password
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isDataLoaded && !editMode" class="container pt-6">
      <div v-show="user.userRole == 'SystemAdmin' || user.userRole == 'Support' ? false : true">
        <span v-if="userDetails.isSiteTeamUser">
          <studySiteAssociation :data="userDetails.userSite" :userRole="userDetails.userRole" :isSiteTeamUser="userDetails.isSiteTeamUser" :isProfile="true"> </studySiteAssociation>
        </span>
        <span v-if="!userDetails.isSiteTeamUser">
          <studySiteAssociation :data="userDetails.userStudies" :userRole="userDetails.userRole" :isSiteTeamUser="userDetails.isSiteTeamUser" @dataAccessChangeChild="dataAccessChangeParent" :isProfile="true"> </studySiteAssociation>
        </span>
      </div>
    </div>
    <div v-if="isDataLoaded && canNotificationAccess()" class="container pt-20">
      <span v-if="userDetails.isSiteTeamUser">
        <ProfileNotificationSetting :userSite="userDetails.userSite"></ProfileNotificationSetting>
      </span>
      <span v-if="!userDetails.isSiteTeamUser">
        <ProfileNotificationSetting :userSite="userDetails.userStudies"></ProfileNotificationSetting>
      </span>
    </div>
    <div class="row bottom_footer">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <p class="text-center font-size10">Questions or need help ?</p>
        <Copyright />
      </div>
    </div>
    <div id="avatarUpdate" role="dialog" class="modal fade in" data-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content p-20 pl-30 pr-30">
          <div class="row text-center pt-30 pb-20">
            <span class="editAvtar">Edit avatar</span>
          </div>
          <div class="row">
            <center>
              <vue-cropper ref="cropper" :guides="true" drag-mode="move" :view-mode="3" :minContainerHeight="180" :minContainerWidth="180" :minCanvasHeight="180" :minCanvasWidth="180" :img="profileImage" :cropBoxResizable="false" :minCropBoxWidth="150" :minCropBoxHeight="150" :zoomable="false" :imgStyle="imgStyle" alt="Source Image" class="vue-cropper"> </vue-cropper>
            </center>
          </div>
          <div class="row text-center pt-20 pb-10">
            <button type="button" class="btn btn-md save-btn primaryBgColor" v-on:click="resizeImage(profileImage)">
              Save
            </button>
          </div>
          <div class="row text-center pt-10 pb-20">
            <button type="button" class="btn btn-md cancel-btn ml-20" v-on:click="cancelAvatar">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <verifyIdentityModal
      :userInfo="{
        oldEmail: this.userEmailAddress,
        newEmail: this.user.username,
        userId: this.userDetails.id
      }"
      @otpVerified="updateUserProfile"
      ref="verifyEmailModal"
      :lang="lang"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VueCropper from "vue-cropperjs";
import MainHeader from "../common/main-header";
import Copyright from "../common/copyright";
import swal from "sweetalert2";
import ProfileNotificationSetting from "./profile-notification-setting";
import studySiteAssociation from "../users/study-site-association";
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import { Auth } from "aws-amplify";
import verifyIdentityModal from "@/components/profile/verify-identity-modal";

export default {
  name: "Profile",
  components: {
    VueCropper,
    mainheader: MainHeader,
    Copyright,
    ProfileNotificationSetting,
    studySiteAssociation,
    verifyIdentityModal
  },
  computed: {
    ...mapGetters(["awsCognitoAuthentication"]),
    lang() {
      let selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    }
  },
  data() {
    return {
      validMobile: false,
      validWork: false,
      removePhotoToggle: true,
      changePasswordToggle: true,
      disableChangePassword: true,
      profileImage: null,
      profileData: {},
      user: {
        firstName: "",
        lastName: "",
        username: "",
        userRole: "",
        userRoleUI: "",
        phoneNumber: "",
        workNumber: "",
        activityLibraryAllowed: false,
        profileImage: null,
        client: {
          name: ""
        }
      },
      altImage: "/static/img/profile.png",
      password: {
        oldPassword: "",
        newPassword: ""
      },
      confirmPassword: "",
      showIcon: false,
      minValid: false,
      upperValid: false,
      numberValid: false,
      lowerValid: false,
      specialValid: false,
      changePassword: false,
      editMode: false,
      msgMatch: false,
      msgOld: "",
      confirmPasswordInput: true,
      changePasswordInput: false,
      infoDiv: false,
      imgStyle: {
        width: "180px",
        height: "180px"
      },
      activityLibraryStatus: false,
      userDetails: {},
      isDataLoaded: false,
      userEmailAddress: null
    };
  },
  mounted() {
    window.$('[data-toggle="popover"]').popover();
    this.id = this.$route.params.id;
    this.getUserDetails();
    this.$api.getProfileDetails(this.id).then(
      response => {
        this.user = response.body;
        this.userEmailAddress = response.body.username;
        if (this.user.phoneNumber) {
          this.$refs.userPhoneNumber.phone = this.user.phoneNumber;
          this.validMobile = true;
        }
        if (this.user.workNumber) {
          this.$refs.userWorkNumber.phone = this.user.workNumber;
          this.validWork = true;
        }
        if (!this.user.client) {
          this.user.client = {
            name: ""
          };
        }
        if (this.user.profileImage) {
          this.profileImage = this.user.profileImage;
        }
        if (this.user.userRole === "SystemAdmin") {
          this.user.userRoleUI = "Platform Admin";
        } else if (this.user.userRole === "StudyAdmin") {
          this.user.userRoleUI = "Study Admin";
        } else if (this.user.userRole === "Cra") {
          this.user.userRoleUI = "Clinical Research Associate (Blinded)";
        } else if (this.user.userRole === "CraUB") {
          this.user.userRoleUI = "Clinical Research Associate (Unblinded)";
        } else if (this.user.userRole === "Dm") {
          this.user.userRoleUI = "Data Management";
        } else if (this.user.userRole === "Pi") {
          this.user.userRoleUI = "Principal Investigator";
        } else if (this.user.userRole === "SubPi") {
          this.user.userRoleUI = "Sub-Investigator";
        } else if (this.user.userRole === "StudyCoordinator") {
          this.user.userRoleUI = "Study Coordinator";
        } else if (this.user.userRole === "Quality") {
          this.user.userRoleUI = "Quality";
        } else if (this.user.userRole === "HomeHealth") {
          this.user.userRoleUI = "Home Health";
        } else if (this.user.userRole === "StudyManager") {
          this.user.userRoleUI = "Study Manager";
        } else if (this.user.userRole === "Biostatistics") {
          this.user.userRoleUI = "Biostatistics";
        } else if (this.user.userRole === "Pharmacovigilance") {
          this.user.userRoleUI = "Pharmacovigilance";
        } else if (this.user.userRole === "SiteDataLock") {
          this.user.userRoleUI = "Site - Data Lock";
        } else if (this.user.userRole === "CallCenter") {
          this.user.userRoleUI = "Call Center";
        } else if (this.user.userRole === "Interviewer") {
          this.user.userRoleUI = "Interviewer";
        } else if (this.user.userRole === "Rater") {
          this.user.userRoleUI = "Rater";
        } else if (this.user.userRole === "Support") {
          this.user.userRoleUI = "Support";
        }
      },
      error => {
        this.errorMsg = error.body && error.body.message ? error.body.message : "Error while getting the profile details";
        this.$toastr.error(this.errorMsg);
      }
    );
  },
  methods: {
    ...mapActions(["userUpdate"]),
    toggleInfoDiv() {
      if (this.infoDiv) {
        this.hidePopup();
      } else {
        this.showPopup();
      }
    },
    showPopup() {
      this.infoDiv = true;
      this.$el.focus();
    },
    hidePopup() {
      this.infoDiv = false;
      this.$el.blur();
    },
    validMobileNumber(mobileNumber) {
      const mobPattern = new RegExp("^\\+[0-9]{1,3}[0-9]{10,14}(?:x.+)?$");
      if (mobPattern.test(mobileNumber)) {
        this.validMobile = false;
      } else {
        this.validMobile = true;
      }
    },
    editProfile() {
      this.$refs.userPhoneNumber.phone = "";
      this.$refs.userWorkNumber.phone = "";
      this.editMode = true;
      this.changePassword = false;
      setTimeout(() => {
        this.$refs.userPhoneNumber.phone = this.user.phoneNumber;
        this.$refs.userWorkNumber.phone = this.user.workNumber;
      }, 1000);
    },
    onInputUserPhone({ number, isValid, country }) {
      this.validMobile = isValid;
      const numberCopy = number;
      let phoneNoCopy = "";
      if (typeof numberCopy === "object") {
        phoneNoCopy = numberCopy.input
          .toString()
          .replace(country.dialCode, "")
          .replace(/\s/g, "")
          .replace(/[^a-zA-Z0-9 ]/g, "");
      } else {
        phoneNoCopy = numberCopy
          .toString()
          .replace(country.dialCode, "")
          .replace(/\s/g, "")
          .replace(/[^a-zA-Z0-9 ]/g, "");
      }
      if (phoneNoCopy.length > 0) {
        this.user.phoneNumber = `+${country.dialCode}${phoneNoCopy.replace(/\s/g, "")}`;
      } else {
        this.user.phoneNumber = "";
      }
    },
    onInputWorkNumber({ number, isValid, country }) {
      this.validWork = isValid;
      const numberCopy = number;
      let phoneNoCopy = "";
      if (typeof numberCopy === "object") {
        phoneNoCopy = numberCopy.input
          .toString()
          .replace(country.dialCode, "")
          .replace(/\s/g, "")
          .replace(/[^a-zA-Z0-9 ]/g, "");
      } else {
        phoneNoCopy = numberCopy
          .toString()
          .replace(country.dialCode, "")
          .replace(/\s/g, "")
          .replace(/[^a-zA-Z0-9 ]/g, "");
      }
      if (phoneNoCopy.length > 0) {
        this.user.workNumber = `+${country.dialCode}${phoneNoCopy.replace(/\s/g, "")}`;
      } else {
        this.user.workNumber = "";
      }
    },
    validWorkNumber(workNumber) {
      const workPattern = new RegExp("^\\+[0-9]{1,3}[0-9]{10,14}(?:x.+)?$");
      if (workPattern.test(workNumber)) {
        this.validWork = false;
      } else {
        this.validWork = true;
      }
    },
    showChangePassword() {
      this.changePasswordToggle = true;
      this.changePassword = true;
      this.editMode = false;
    },
    removePhoto() {
      this.profileImage = null;
      this.removePhotoToggle = false;
    },
    validNewPassword(password) {
      this.disableChangePassword = true;
      this.confirmPassword = "";
      this.confirmPasswordInput = true;
      this.showIcon = true;
      this.lowerValid = false;
      this.upperValid = false;
      this.valid = false;
      this.specialValid = false;
      this.numberValid = false;
      const lowerPattern = new RegExp("^(?=.*[a-z]).+$");
      const upperPattern = new RegExp("^(?=.*[A-Z]).+$");
      const numberPattern = new RegExp("^(?=.*[0-9]).+$");
      const specialPattern = new RegExp("(?=.*[@#$%!^&+=_W]).+$");
      // empty password check
      if (password === "") {
        this.showIcon = false;
      } else if (password.length >= 8) {
        this.minValid = true;
      } else if (password.length < 8) {
        this.minValid = false;
      }
      // lowercase pattern check
      if (lowerPattern.test(password)) {
        this.lowerValid = true;
      }
      // uppercase pattern check
      if (upperPattern.test(password)) {
        this.upperValid = true;
      }
      if (numberPattern.test(password)) {
        this.numberValid = true;
      }
      if (specialPattern.test(password)) {
        this.specialValid = true;
      }
      if (this.minValid && this.lowerValid && this.upperValid && this.numberValid && this.specialValid) {
        this.confirmPasswordInput = false;
      }
    },
    validConfirmPassword(password) {
      this.disableChangePassword = true;
      if (password !== this.password.newPassword) {
        this.msgMatch = true;
      } else {
        this.disableChangePassword = false;
        this.changePasswordInput = true;
        this.msgMatch = false;
      }
    },
    cancelPassword() {
      this.changePasswordToggle = true;
      this.password.oldPassword = "";
      this.password.newPassword = "";
      this.confirmPassword = "";
      this.showIcon = false;
      this.confirmPasswordInput = false;
      this.changePasswordInput = false;
      this.changePassword = true;
      this.msgMatch = false;
      this.msgOld = "";
    },
    async updatePassword(password) {
      if (this.changePasswordInput && this.msgMatch === false) {
        if (this.awsCognitoAuthentication && this.awsCognitoAuthentication === true) {
          try {
            const cognitoUser = await Auth.currentAuthenticatedUser();
            await Auth.changePassword(cognitoUser, this.password.oldPassword, this.password.newPassword, { userType: "portal", requestFor: "RESET_PASSWORD", requestFrom: "web" });
            this.$toastr.success("Password Updated!");
            this.changePassword = false;
            this.password.oldPassword = "";
            this.password.newPassword = "";
            this.confirmPassword = "";
          } catch (error) {
            let errorMsg = error.message;
            if (error.message == "Incorrect username or password.") {
              errorMsg = "Old password is incorrect";
            }
            this.msgOld = errorMsg;
          }
        } else {
          this.$api.updatePasswordDetails(this.id, password).then(
            response => {
              if (response.body.success) {
                this.changePassword = false;
                this.password.oldPassword = "";
                this.password.newPassword = "";
                this.confirmPassword = "";
                this.$toastr.success(response.body.message);
              } else {
                this.msgOld = response.body.message;
              }
            },
            error => {
              this.msgOld = error.body && error.body.message ? error.body.message : "Error while updating the password";
              this.errorMsg = this.msgOld;
              if (error.body && error.body.status && error.body.status === 401) {
                this.$toastr.error(this.errorMsg);
              }
            }
          );
        }
      } else if (this.password.oldPassword === "") {
        this.changePasswordInput = false;
      } else if (this.password.newPassword !== this.confirmPassword || this.password.newPassword === "" || this.confirmPassword === "") {
        this.msgMatch = true;
      } else {
        this.msgMatch = false;
        this.msgOld = "";
      }
    },
    cancelProfile() {
      swal({
        title: "Are you sure you want to cancel?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#34537d",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$api.getProfileDetails(this.id).then(
            response => {
              this.user = response.body;
              if (this.user.profileImage) {
                this.profileImage = this.user.profileImage;
              }
              this.editMode = false;
            },
            error => {
              this.user.firstName = "";
              this.user.lastName = "";
              this.user.phoneNumber = "";
              this.user.workNumber = "";
              this.user.profileImage = null;
              const { message = "Error while getting the profile details" } = (error && error.body) || {};
              this.errorMsg = message;
              this.$toastr.error(this.errorMsg);
              this.edit = false;
            }
          );
        }
      });
    },
    updateProfileSave() {
      this.user.profileImage = this.profileImage;
      if (this.user.firstName && this.user.lastName && this.user.username) {
        if (this.userEmailAddress.toLowerCase() != this.user.username.toLowerCase()) {
          this.$refs.verifyEmailModal.show();
        } else {
          this.updateUserProfile();
        }
      } else {
        if (this.user.firstName === "" || this.user.firstName === null || this.user.firstName === undefined) {
          this.$toastr.error("please enter first name");
        } else if (this.user.lastName === "" || this.user.lastName === null || this.user.lastName === undefined) {
          this.$toastr.error("please enter last name");
        } else if (this.user.username === "" || this.user.username === null || this.user.username === undefined) {
          this.$toastr.error("please enter email");
        }
      }
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      window.$("#avatarUpdate").modal("show");
      this.createImage(files[0]);
    },
    createImage(file) {
      this.profileImage = new window.Image();
      const reader = new window.FileReader();
      const vm = this;
      reader.onload = e => {
        vm.profileImage = e.target.result;
        this.$refs.cropper.replace(e.target.result);
      };
      reader.readAsDataURL(file);
      window.document.getElementById("avatarImage").value = null;
    },
    resizeImage() {
      this.removePhotoToggle = true;
      this.profileImage = this.$refs.cropper.getCroppedCanvas().toDataURL();
      window.$("#avatarUpdate").modal("hide");
    },
    cancelAvatar() {
      if (this.user.profileImage) {
        this.profileImage = this.user.profileImage;
      } else {
        this.profileImage = null;
      }
      window.document.getElementById("avatarImage").value = null;
      window.$("#avatarUpdate").modal("hide");
    },
    canNotificationAccess() {
      if (this.user.userRole === "Pi" || this.user.userRole === "SubPi" || this.user.userRole === "StudyCoordinator" || this.user.userRole === "HomeHealth" || this.user.userRole === "Cra" || this.user.userRole === "CraUB" || this.user.userRole === "Dm" || this.user.userRole === "Quality" || this.user.userRole === "CallCenter") {
        return true;
      } else {
        return false;
      }
    },
    getUserDetails() {
      nprogress.start();
      this.isDataLoaded = false;
      this.$api.getInstantUserDataFact(this.id).then(
        response => {
          this.userDetails = response.body;
          nprogress.done();
          this.isDataLoaded = true;
          if (this.userDetails.phoneNumber) {
            this.$refs.userPhoneNumber.phone = this.userDetails.phoneNumber;
            this.validMobile = true;
          }
          if (this.userDetails.workNumber) {
            this.$refs.userWorkNumber.phone = this.userDetails.workNumber;
            this.validWork = true;
          }
        },
        error => {
          nprogress.done();
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting user details.");
        }
      );
    },
    updateUserProfile() {
      if (this.checkPhoneValidation()) {
        this.$api.editProfileDetails(this.id, this.user).then(
          profile => {
            this.profileData = profile;
            this.userEmailAddress = profile.username;
            this.userUpdate(profile);
            this.$toastr.success("Profile updated successfully.");
            this.editMode = false;
          },
          error => {
            const { message = "Error while updating the profile" } = (error && error.body) || {};
            this.errorMsg = message;
            this.$toastr.error(this.errorMsg);
          }
        );
      }
    },
    checkPhoneValidation() {
      let validFlag = true;
      if (!this.validMobile && this.user.phoneNumber && this.user.phoneNumber.length > 0) {
        validFlag = false;
        this.$toastr.error("Phone number is invalid");
      }
      if (!this.validWork && this.user.workNumber && this.user.workNumber.length > 0) {
        validFlag = false;
        this.$toastr.error("Work number is invalid");
      }
      return validFlag;
    },
    dataAccessChangeParent(item) {
      this.$api.updateDataAccessFact(item.studyId, item.userId, item.userDataAccessType).then(
        () => {
          this.$toastr.success("User data access type updated successfully");
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while updating the user data access type.");
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
.studies_bg {
  background-size: cover;
  height: 100%;
  min-height: 100vh;
  background-color: #f5f8fa;
  background-blend-mode: soft-light;
}
.profile {
  font-size: 24px;
  line-height: 1.87;
  font-family: Roboto-Regular;
  font-weight: lighter;
}
.input-display {
  display: none;
}
/deep/ .col {
  padding: 0px !important;
}
.card-height {
  height: 150px;
}
.editProfile {
  padding: 10px 30px 10px 30px;
  border-radius: 100px;
  border: none;
  background-color: #2d3752;
}
.contents {
  margin-left: 19px;
  margin-right: 19px;
  color: #959fa4;
}
.white-bg {
  background: #fff;
}
.editableText {
  background-color: white;
  border: 0px !important;
  width: 100%;
  word-break: break-all !important;
  // border-top: 1px solid #eeeeee !important;
  font-weight: 300;
  font-size: 18px;
  color: #888 !important;
  margin-left: -84px;
  margin-bottom: 22px;
}
.editableText:focus {
  outline: 0px solid transparent;
}
.disableText {
  opacity: 0.5 !important;
}
.emptyText {
  font-size: 18px;
  opacity: 0.8 !important;
}
.fullName {
  background-color: white;
  border: 0px !important;
  color: #888 !important;
  word-break: break-all;
  font-weight: 300;
  font-size: 17px;
  width: 175px;
  border: 1px solid #bfbfbf !important;
  margin-bottom: -15px !important;
}
.fullName:focus {
  outline: 0px solid transparent;
}
.changePassword {
  padding: 8px 30px 8px 30px;
  border-radius: 100px;
  background-color: #51dd75;
  color: white;
  border: none;
}
ul.validation-list li {
  list-style-type: disc !important;
  padding-bottom: 5px;
  font-size: 14px;
  font-weight: normal;
}
.icon-invalid {
  color: red;
}
.icon-valid {
  color: limegreen;
}
.cancel-btn {
  width: 130px;
  height: 40px;
  border-radius: 100px;
  background-color: #959fa4;
  color: #fff;
}
.save-btn {
  padding: 0px 5px 0px 5px;
  width: 170px;
  height: 40px;
  border-radius: 100px;
  background-color: #51dd75;
  color: #fff;
}
.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
  padding-left: 0;
}
img {
  display: inline;
}
.removepic {
  border: none;
  color: red;
  font-size: 17px;
}
.editAvtar {
  font-size: 20px;
  color: #1f95f2;
}
.saveAvatar {
  border: none;
  border-radius: 100px;
  padding: 10px 120px 10px 120px;
  background-color: #1f95f2;
}
.cancelAvatar {
  color: #959fa4;
}
.vue-cropper {
  display: inline !important;
  width: 180px !important;
  height: 180px !important;
}
.delete {
  padding-left: 20px;
  border-left: 1px solid;
  color: #4b8bf2;
}
.bottom_footer {
  position: relative;
  bottom: 0px;
  width: 100%;
  padding-top: 20px;
  color: #fff;
  clear: both;
}
.font-size10 {
  font-size: 10px;
  margin: 0px !important;
}
button {
  cursor: pointer;
}
button:focus {
  outline: 0px solid transparent;
}
a {
  cursor: pointer;
}
.text-right {
  text-align: right;
}
.text-dec {
  text-decoration: underline;
  color: #888;
}

@media (min-width: 168px) and (max-width: 991px) {
  .container-width {
    width: 100% !important;
  }
}
.primaryBgColor {
  background-color: #1e8fe1;
}

.setting-btn-text {
  position: relative;
  right: 5px;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: #b0bac9;
}

.switch-option {
  float: left;
  width: 100%;
}

.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
  float: left;
  margin-right: 10px;
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.filds_section {
  border-radius: 8px;
  padding: 0 10px 10px;
  background-color: #ffffff;
  border: solid 1px #d3dfe4;
  min-height: 150px;
}
.info-circle-div {
  width: 280px;
  height: 80px;
  background-color: #ffffff;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #666669;
  padding: 13px 16px 19px 13px;
  position: absolute;
  border-radius: 3px;
  margin-left: 150px;
  margin-top: 0px;
  box-shadow: 1px 1px #d3deef;
}
.profile-info-2 {
  width: 1108px;
  height: 211px;
  // margin: 17px 165px;
  padding: 28px 28px 25px 31px;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
}
.table-card {
  color: #959fa4;
  margin-top: -28px;
}
.StudY-table-head {
  width: 32px;
  height: 12px;
  margin: 5px 112px 9px 31px;
  opacity: 0.5;
  font-family: Roboto-Regular;
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #666669;
}
.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
  top: 0px;
  left: 6px;
}
/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
/* Rounded sliders */
.un-bld-Lbl-Txt {
  color: #666669 !important;
  opacity: 0.5;
  position: relative;
  top: -14px;
  right: 1px;
}
.bld-Lbl-Txt {
  color: #666669 !important;
  opacity: 0.5;
  position: relative;
  top: -14px;
  left: 10px;
}
.help_icon {
  color: #b8c7ce;
  border: none !important;
  outline: none !important;
}
.info-msg {
  position: relative;
  left: 13px;
  top: -14px;
}
.Deactivate-from-site-study {
  font-family: Roboto-Regular;
  color: #f16559;
}
.activate-txt {
  font-family: Roboto-Regular;
  color: #1e8fe1;
}
.name-txt {
  width: 89px;
  height: 20px;
  margin: -19px 182px 3px -81px;
  font-family: Roboto-Regular;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: #bfbfbf;
  padding-top: 20px;
}
.name-txt-1 {
  height: 20px;
  margin: -19px 184px 3px -81px;
  font-family: Roboto-Regular;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: #bfbfbf;
  padding-top: 30px;
}
.ml-762 {
  text-align: right;
}
.Change-password {
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4c8ce4;
  cursor: pointer;
  width: auto;
  display: inline-block;
}
.edit-box {
  margin-left: 15px;
  width: auto;
  display: inline-block;
  padding: 5px 20px 7px 20px;
  border-radius: 3px;
  border: solid 2px #d3dfe4;
  font-family: Roboto-Regular;
  font-size: 12px;
  color: #4c8ce4;
  text-align: center;
  cursor: pointer;
  height: 32px !important;
}
.input-txt-2 {
  width: 255px;
  margin: -2px 66px 4px -42px;
  padding: 3px 0px 3px 9px;
  opacity: 0.7;
  font-family: Roboto-Regular;
  font-size: 18px;
  line-height: normal;
  color: #666669;
  box-shadow: none !important;
  border: 1px solid #bbb;
  outline: none;
  box-shadow: none !important;
  border-radius: 4px;
}
.vue-tel-input {
  margin: 0px 94px 0px -82px;
}
.associalte-tbl {
  margin-left: 107px !important;
}
.save-btn-2 {
  width: 154px;
  height: 36px;
  border-radius: 3px;
  border: solid 2px #4c8ce4;
  background-color: #4c8ce4;
  color: #fff;
}

.cancel-btn-2 {
  width: 130px;
  border-radius: 100px;
  background-color: #fff;
  color: #b8c7ce;
}
.file-upload {
  position: relative;
  overflow: hidden;
  border: none;
  border-radius: 3px;
  padding: 7px 10px 8px 10px;
  display: inline;
  background-color: #d3dfe4;
  margin-right: 6px;
}
.profile-info {
  margin-left: 22px !important;
}
.lable-f {
  margin-left: -97px !important;
}

.f-input {
  background: #fff;
  border: 0px !important;
  color: #888 !important;
  font-size: 17px;
  width: 167px;
  border: 1px solid #bfbfbf !important;
  margin-bottom: -15px !important;
  margin-left: -37px !important;
}
.color_top {
  color: #666669;
}

.name-avtar {
  font-family: Roboto-Regular;
  font-size: 12px;
  font-weight: bold;
  color: #bfbfbf;
}
.edit-email-input {
  border: 1px solid #bfbfbf !important;
  color: #888 !important;
  margin-left: -80px;
}
.roleInputWidth {
  width: 327px;
}
</style>
